'use client'
import React, { Suspense, useContext } from 'react'

import { BRAND, COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID, COUNTRY_ID } from '@/data/constants';
import { Route } from '@/routers/routes';
import Link from 'next/link';
import { isActiveLink } from '@/library/utils/links';
import { usePathname } from 'next/navigation';
import LoginModal from '@/library/entities/core/user/components/authentication/LoginModal';
import { UserContext } from '@/library/entities/core/user/contexts/UserContext';
import MeAvatar from '@/library/entities/core/user/components/MeAvatar';
export default function NavigationDefault(props) {
  const {
    className = "",
  } = props
  const pathname = usePathname()
  const { isAuthenticated, me } = useContext(UserContext)
  const navigationItems = {
    [COUNTRY_SWEDEN_ID]: [
      { name: 'Artiklar', href: Route.EditorialContentList(COUNTRY_ID) },
      { name: 'Aktier', href: Route.instrumentList(COUNTRY_ID) },
    ],
    [COUNTRY_UAE_ID]: [
      // { name: 'Community', href: Route.UAEPortfolioList(COUNTRY_ID) },
      { name: 'Insights', href: Route.EditorialContentList(COUNTRY_ID) },
      { name: 'Stocks', href: Route.instrumentList(COUNTRY_ID) },
      // { name: 'Activity', href: Route.threadsAll(COUNTRY_ID) }
    ]
  }
  const items = navigationItems[COUNTRY_ID]
  return (
    <>
      <nav className={`${className} absolute top-0 left-2 right-2 max-w-7xl mx-auto bg-white text-primary rounded-full flex justify-between items-center px-5 md:px-8 py-2 z-50 mt-4`}>
        <div className="font-bold uppercase"><Link href={Route.loginRedirect(COUNTRY_ID)}>{BRAND.name}</Link></div>
        <div className="flex gap-2 sm:gap-6 font-medium items-center text-sm">
          {items.map((item) => {
            const isActive = isActiveLink(pathname, item.href)
            const textColor = isActive ? 'text-primary font-extrabold' : 'text-primary'
            return (
              <Link key={item.name} href={item.href} className={`${textColor} py-1.5`}>{item.name}</Link>
            )
          })}
          <Suspense>
            {isAuthenticated && me ? (
              <MeAvatar countryId={COUNTRY_ID} me={me} size="sm" />
            ) : (
              <LoginModal size="md" countryId={COUNTRY_ID} trigger={<button className="ml-0 md:ml-4 bg-primary py-1 px-5 text-white rounded-full">Login</button>} />
            )}

          </Suspense>
        </div>
      </nav>
    </>
  )
}
